import { Button, ButtonsWrapper, Form, Modal, TextInput } from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';
import { useCreateKWPConnection } from 'src/hooks/interfaces/kwp/create-kwp-connection.hook';
import { useGetCurrentAccount } from 'src/hooks/accounts/get-current-account.hook';
import { useUpdateKWPConnection } from 'src/hooks/interfaces/kwp/update-kwp-connection.hook';
import { useGetKWPConnectionByUserId } from 'src/hooks/interfaces/kwp/get-kwp-connection.hook';
import { FormContainer } from './modals.styles';
import { redirectToAuth } from '../helpers';

const CreateKWPConnectionModal = ({
  onClose,
  codeChallenge,
  codeVerifier,
}: {
  onClose: () => void;
  codeChallenge: string | null;
  codeVerifier: string | null;
}) => {
  const { t } = useTranslation(['common', 'settings']);
  const [form] = Form.useForm();

  const { account } = useGetCurrentAccount();
  const { interfaceConnection } = useGetKWPConnectionByUserId(account._id);
  const { createConnection } = useCreateKWPConnection();
  const { updateConnection } = useUpdateKWPConnection();

  const connectionHandler = !interfaceConnection ? createConnection : updateConnection;

  const onFinish = (values: any) => {
    connectionHandler({
      variables: {
        payload: {
          interfaceName: 'KWP',
          createdBy: account._id,
          link: values.link,
          codeVerifier,
          codeChallenge,
        },
      },
    })
      .then(({ data }) => {
        redirectToAuth(
          !interfaceConnection ? data.createInterface.link : data.updateInterface.link,
          !interfaceConnection
            ? data.createInterface.codeChallenge
            : data.updateInterface.codeChallenge
        );
      })
      .then(() => onClose());
  };

  return (
    <Modal
      isOpened
      title={t('settings:interfaces.labels.title')}
      onClose={onClose}
      modalWidth={336}
    >
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <FormContainer>
          <div>
            <Form.Item
              name="link"
              label="Link"
              rules={[
                { required: true, message: t('settings:interfaces.validationError.linkRequired') },
              ]}
            >
              <TextInput placeholder="Your KWP link" maxLength={150} />
            </Form.Item>
          </div>
        </FormContainer>
        <ButtonsWrapper>
          <Button htmlType="submit" type="primary">
            {t('common:buttons.connect')}
          </Button>
          <Button onClick={onClose}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </Modal>
  );
};

export default CreateKWPConnectionModal;
